/**
 * 项目服务组件
 * zxw
 * 2024-01-17
 */
import React, { } from 'react';
import { Row, Col } from 'antd';

import WOWTCD from '../plmss/WOWTCD.js';
import WOWDCT from '../plmss/WOWDCT.js';
import WOWDCL from '../plmss/WOWDCL.js';

const Plms = (props) => {

    return <>
        {
            props && props.btnLists.indexOf('btn_plms_report_wo_wtcd') >= 0 && props.btnLists.indexOf('btn_plms_om') >= 0 ? <div style={{
                margin: '10px 5px 0 0', padding: '10px 20px 20px 20px', background: '#fff',
                border: '1px solid #E8E8E8',
                borderRadius: '5px',
                boxShadow: '0 0 5px 2px #E8E8E8',
            }}>
                <p>工单每日数量走势</p>
                <WOWTCD />
            </div> : ''
        }
        <Row>
            {
                props && props.btnLists.indexOf('btn_plms_report_wo_wdct') >= 0 && props.btnLists.indexOf('btn_plms_om') >= 0 ? <Col span={12}>
                    <div style={{
                        margin: '10px 5px 0 0', padding: '10px 20px 20px 20px', background: '#fff',
                        border: '1px solid #E8E8E8',
                        borderRadius: '5px',
                        boxShadow: '0 0 5px 2px #E8E8E8',
                    }}><p>工单年度类型统计</p>
                        <WOWDCT />
                    </div>
                </Col> : ''
            }
            {
                props && props.btnLists.indexOf('btn_plms_report_wo_wdcl') >= 0 && props.btnLists.indexOf('btn_plms_om') >= 0 ? <Col span={12}>
                    <div style={{
                        margin: '10px 5px 0 0', padding: '10px 20px 20px 20px', background: '#fff',
                        border: '1px solid #E8E8E8',
                        borderRadius: '5px',
                        boxShadow: '0 0 5px 2px #E8E8E8',
                    }}><p>工单年度等级统计</p>
                        <WOWDCL />
                    </div>
                </Col> : ''
            }
        </Row>
    </>
}

export default Plms;